export enum WindowVertDivisions {
  SINGLE = "SINGLE",
  TWIN = "TWIN",
  TRIPLE = "TRIPLE",
}

export enum PolygonWindowMode {
  TRAPEZOIDAL_LEFT = "TRAPEZOIDAL_LEFT",
  TRAPEZOIDAL_RIGHT = "TRAPEZOIDAL_RIGHT",
  PENTAGONAL = "PENTAGONAL",
}

export enum WindowPaneType {
  FULL = "FULL",
  TOP = "TOP",
  LOW = "LOW",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export enum WindowOperationType {
  FIXED = "FIXED",
  AWNING = "AWNING",
  SLIDING = "SLIDING",
  CASEMENT = "CASEMENT",
  SINGLE_HUNG = "SINGLE_HUNG",
  DOUBLE_HUNG = "DOUBLE_HUNG",
}

export enum WindowPanelType {
  GLAZING = "GLAZING",
  FAUX_SHUTTER = "FAUX_SHUTTER",
  VENT = "VENT",
  SCREEN = "SCREEN",
}

export enum GlazingType {
  STANDARD = "STANDARD",
  TEMPERED = "TEMPERED",
  IMPACT = "IMPACT",
}

export enum GlazingColor {
  CLEAR = "CLEAR",
  FROSTED = "FROSTED",
  BACK_PAINTED = "BACK_PAINTED",
  TEXTURED = "TEXTURED",
}

export enum ArchTopBoolean {
  ADD = "ADD",
  SUBTRACT = "SUBTRACT",
}

export enum WindowShapeTypes {
  RECTANGLE = "RECTANGLE",
  RECTANGLE_ARCHED_TOP = "RECTANGLE_ARCHED_TOP",
  CIRCLE = "CIRCLE",
  HALF_ROUND = "HALF_ROUND",
  ELLIPSE = "ELLIPSE",
  POLYGONAL = "POLYGONAL",
}
